// state to render
// According to the state rendering, the material's object switches
// to the correct state material
export default {
    // final color
    FINAL: 0,
    // depth buffer
    DEPTH: 1,
    // id object
    ID: 2,
};



// WEBPACK FOOTER //
// ./src/Renderer/RendererConstant.js